import FontPreview from '../../components/fontPreview'

const mountSelector = '#item-font-preview'
const element = document.querySelector(mountSelector)
const fontFilenames = JSON.parse(element.dataset.fontFilenames)

new FontPreview({
  serviceEndpoint: element.dataset.fontPreviewServiceEndpoint,
  itemId: element.dataset.itemId,
  version: element.dataset.version,
  itemName: element.dataset.itemName,
  fontFilenames: fontFilenames,
  rootElement: mountSelector
}).render()
